<template>
  <div>
      <TaxRollAdjustmentReport />

  </div>
</template>

<script>
import TaxRollAdjustmentReport from '../../../components/tax/TaxInquiry/Reports/TaxRollAdjustmentReport.vue';

export default {
  name: 'taxRollAdjustmentReport',
  components: {
    TaxRollAdjustmentReport,
  },
};

</script>
